import type { GetProductReviewsRequest, ReviewStatisticsRequest } from './types';

export const REVIEW_QUERY_KEYS = {
  default: () => ['review'] as const,
  getProductReviews: (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) =>
    [...REVIEW_QUERY_KEYS.default(), 'product', productId, params] as const,
  getAIProductReviews: (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) =>
    [...REVIEW_QUERY_KEYS.default(), 'product', productId, 'ai', params] as const,
  getCuratedReviews: () => [...REVIEW_QUERY_KEYS.default(), 'curated'] as const,
  getReviewStatistics: (params: ReviewStatisticsRequest) =>
    [...REVIEW_QUERY_KEYS.default(), 'statistics', params] as const,
};

export const REVIEW_MUTATION_KEYS = {
  createReview: () => ['review', 'create'] as const,
};
